<template>
  <ValidationProvider :rules="rules" :vid="prefixLabel + ' ' + label" immediate v-slot="{ failed }">
    <md-datepicker
        :value="value" 
        v-on:input="$emit('input', $event)" 
        md-immediately 
        :md-open-on-focus="false" 
        :disabled="disabled" 
        :class="{ 'md-error': failed }"
        :readonly="readonly"
        @keyup.native="validateDateInput($event.target._value)"
        :md-disabled-dates="disableDates"
        :md-model-type="String">
      <md-icon v-if="icon">{{ icon }}</md-icon>
      <label>
        {{ label }}
        <span v-if="required">&nbsp;*</span>
      </label>
    </md-datepicker>
    <span v-if="hasError" class="error-msg">{{regexError}}</span>
    <span v-else-if="failed" class="error-msg">Please enter a valid date.</span>
  </ValidationProvider>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";
import moment from "moment";

export default {
  components: {
    SlideYDownTransition,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    regex: {
      type: String,
      default: ""
    },
    prefixLabel: {
      type: String,
      default: "",
    },
    disableDates: {
      type: Function,
    },
    disableFutureDate: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    rules(){

      let rules = [];
      if(this.required) rules.push('required');
      if(this.regex) rules.push(`regex:${this.regex}`);

      return rules.join('|');
    },
  },
  data() {
    return {
      hasError: false,
      regexError: null,
    };
  },
  methods: {
    validateDateInput(date){
      const regex = /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
      const isFutureDate = moment(date,'YYYY-MM-DD').isAfter(moment());
      if(date.length > 0 && regex.test(date) == false){
        this.hasError = true;
        this.regexError = "Please enter a valid date."
      } else if (date.length > 0 && this.disableFutureDate && isFutureDate){
        this.hasError = true;
        this.regexError = "Date can't be future."
      } else{
        this.hasError = false;
        this.regexError = null;
      }
    }
  },
  mounted(){
    let element = this.$el.querySelector('input');
    element.addEventListener("keydown", (event) => {
     event = (event) ? event : window.event;
      const charCode = (event.which) ? event.which : event.keyCode;
      if (
          isNaN(event.key)
          && charCode != 8 //backspace
          && charCode != 9 //Tab
          && charCode != 189 //dash
          && charCode != 37 //left-arrow
          && charCode != 39 //right-arrow
          && !(event.ctrlKey && charCode == 67) 		/* ctrl+c copy		*/
	      && !(event.ctrlKey && charCode == 86) 		/* ctrl+v paste			*/
	      && !(event.ctrlKey && charCode == 88) 		/* ctrl+x cut		*/
          && !(event.ctrlKey && charCode == 65) 		/* ctrl+a select all		*/
        ){
        event.preventDefault();
      } else {
        return true;
      }
    });
    setTimeout(function(){ element.placeholder = 'YYYY-MM-DD'; }, 100);
  },
  updated(){
    let element = this.$el.querySelector('input');
    setTimeout(function(){ element.placeholder = 'YYYY-MM-DD'; }, 100);
  },
};
</script>

<style lang="scss" scoped>
  .disabled{
    opacity: 0.7;
  }
</style>
